<template>
  <div
    class="trustpilot-widget"
    data-locale="fr-FR"
    :data-template-id="widgetId"
    :data-businessunit-id="accountId"
    data-style-height="26px"
    :data-style-width="width"
    data-theme="light"
    data-loaded="0"
  />
</template>

<script>
export default {
  props: {
    width: { type: String, required: true },
  },
  data() {
    return {
      widgetId: this.$trustpilotWidgetTrustScoreId ?? window.TRUSTPILOT_WIDGET_TRUST_SCORE_ID,
    };
  },
  computed: {
    accountId() {
      return this.$trustpilotAccountId ?? window.TRUSTPILOT_ACCOUNT_ID;
    },
  },
  mounted() {
    if (window.Trustpilot) {
      document.querySelectorAll('.trustpilot-widget').forEach((element) => {
        // Set the data-attribute to 1 so it is not activated multiples times
        // eslint-disable-next-line no-param-reassign
        element.dataset.loaded = 1;
        // eslint-disable-next-line no-param-reassign
        window.Trustpilot.loadFromElement(element);
      });
    }
  },
};
</script>
